// Generated by rollup.config.js from .env / .env.local — do not edit, do not commit.
export const ENV = {
  "GIGMA_TOKEN": "l8YLNe22TO4j5tShN4weg5WuDDQY93UX",
  "GIGMA_BASE_URL": "https://api.gigma.ru/api",
  "GIGMA_PRODUCT_ONLINE": "",
  "GIGMA_PRODUCT_BASIC": "33729",
  "GIGMA_PRODUCT_BUSINESS": "33730",
  "GIGMA_PRODUCT_VIP": "33731",
  "GIGMA_DELIVERY_TYPE_ID": "",
  "GIGMA_PAYMENT_TYPE_ID": "",
  "GIGMA_SHOP_ID": ""
};
